<template>
  <span style="margin-right:5px">
    <el-button type="danger" :size="btnSize" @click="deleteConfirm()"
      icon="el-icon-delete">Del</el-button
    >
  </span>
</template>

<script>
import { deleteCreditRecord } from  '@/api/monthlyfeecredits'
export default {
  props: {
    uid:String,
    btnSize: {
      type: String,
      default: "small",
    },
  },

  methods: {
    deleteConfirm() {
      this.$confirm('Are you sure you want to delete this item. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
      
          this.deleteCredit()
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });          
        });
    },
    deleteCredit(){

      deleteCreditRecord(this.uid).then(({result})=>{
        if(result){
          this.$notify({
            title: 'Success',
            message: `Delete Credit successfully`,
            type: 'success',
            duration: 2000
          });
          this.$emit('submited')
        }
      })
    }
  },
};
</script>

<style>
</style>